var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAkarIconsZoomFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_109317)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_109317",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V21H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_109317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.5C21 16.2986 16.2986 21 10.5 21C4.70138 21 0 16.2986 0 10.5C0 4.70138 4.70138 0 10.5 0C16.2986 0 21 4.70138 21 10.5ZM5.25 14.175H13.125V8.4C13.125 8.19317 13.0843 7.98836 13.0051 7.79727C12.926 7.60619 12.8099 7.43256 12.6637 7.28631C12.5174 7.14005 12.3438 7.02404 12.1527 6.94489C11.9616 6.86574 11.7568 6.825 11.55 6.825H3.675V12.6C3.675 13.0177 3.84094 13.4183 4.13631 13.7137C4.28256 13.8599 4.45619 13.976 4.64727 14.0551C4.83836 14.1343 5.04317 14.175 5.25 14.175ZM14.175 12.075L17.325 14.175V6.825L14.175 8.925V12.075Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_109317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkarIconsZoomFill);
export default __webpack_public_path__ + "static/media/akar-icons_zoom-fill.93d55c203f8e0c90bcf8a5a055215057.svg";
export { ForwardRef as ReactComponent };